import { TOGGLE_ACTION_PLAN_DRAWER, TOGGLE_ACTION_PLAN_REGISTER } from '@/redux/mutations';

export const initialState = {
    actionPlanDrawer: false,
    questionTitle: null
};

const propertyReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case TOGGLE_ACTION_PLAN_DRAWER:
            return {
                ...state,
                actionPlanDrawer: !state.actionPlanDrawer
            };
        case 'SET_QUESTION_TITLE':
            return {
                ...state,
                questionTitle: actions.payload
            };
        case TOGGLE_ACTION_PLAN_REGISTER:
            return {
                ...state,
                actionPlanRegister: !state.actionPlanRegister
            };
        default:
            return state;
    }
};

export default propertyReducer;
